import {ErrorMessages} from 'constants/Errors';

import {AxiosResponse} from 'axios';
import {call, put} from 'redux-saga/effects';
import {getSingleBeerStyleData} from 'services/beer-styles';
import {handleError} from 'store/app/error/saga';
import ApiData from 'typescript/interfaces/ApiData';
import BeerStyle from 'typescript/models/BeerStyle';

import {setSingleBeerStyleAC} from '../beerStyleViewSlice';
import {getSingleBeerStyleACS} from '../requests';

export function* getSingleBeerStyleSaga(action: ReturnType<typeof getSingleBeerStyleACS>) {
  const id = action.payload;

  try {
    const response: AxiosResponse<ApiData<BeerStyle>> = yield call(getSingleBeerStyleData, id);

    yield put(setSingleBeerStyleAC(response.data.data));
  } catch (error) {
    yield call(handleError, error, ErrorMessages.DATA);
  }
}
